const imageMimeTypes: ReadonlyArray<string> = Object.freeze(['image/gif', 'image/jpeg', 'image/png']);

export function isImageMimeType(mimeType: string | null | undefined): boolean {
    if (mimeType === null || mimeType === undefined) {
        return false;
    }
    return imageMimeTypes.includes(mimeType.toLowerCase());
}
